module.exports = __webpack_public_path__ + "static/media/jest.450c112d.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/jest.png
// module id = 1544
// module chunks = 0